export enum InputQuestionFormat {
  Currency = 'CURRENCY',
  Text = 'TEXT',
  Percentage = 'PERCENTAGE',
  Number = 'NUMBER',
}
